/* eslint-disable import/no-extraneous-dependencies */
import moment from 'jalali-moment';
import { ar } from 'date-fns/locale';
import { format, getTime } from 'date-fns';
import { formatDistanceToNow } from 'date-fns-jalali';


// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}

export const fToNowAr = (jalaliDate) => {
  const gregorianDate = moment(jalaliDate).format('YYYY-MM-DD');
  const timeDistance = formatDistanceToNow(gregorianDate, {
    locale: ar,
    addSuffix: true,
    includeSeconds: false,
    roundingMethod: 'floor',
    format: 'x ساعة'
  });

  return `${timeDistance}`
};

